var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogExpandRowsHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_log_expand_rows_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6209093,6.5 C11.7799814,6.5 11.9390534,6.57601633 12.060843,6.72883265 L12.060843,6.72883265 L13.8187138,8.9458449 C14.0604287,9.25226122 14.0604287,9.74754286 13.8187138,10.0539592 L13.8187138,10.0539592 L12.060843,12.2701878 C11.8178853,12.5766041 11.4245547,12.5766041 11.1822183,12.2701878 C10.9392606,11.9645551 10.9392606,11.4677061 11.1822183,11.1628571 L11.1822183,11.1628571 L11.707,10.5 L4.67598017,10.5 C4.33154227,10.5 4.04700662,10.118463 4.00527,9.62581897 L4,9.50049975 C4,8.94877561 4.30283912,8.5 4.67598017,8.5 L4.67598017,8.5 L11.708,8.5 L11.1822183,7.83694694 C10.9635563,7.56187755 10.9416901,7.13255771 11.1166197,6.82606694 L11.1822183,6.72883265 C11.3027651,6.57601633 11.4624586,6.5 11.6209093,6.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_log_expand_rows_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#06749F",
    fillRule: "nonzero",
    transform: "translate(9.000000, 9.500000) rotate(90.000000) translate(-9.000000, -9.500000) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24295775,2.72883265 C6.91901408,3.03524898 6.91901408,3.53131429 7.24295775,3.83694694 L9.00020713,5.49990204 L7.24295775,7.16285714 C6.91901408,7.46770612 6.91901408,7.9645551 7.24295775,8.27018776 C7.56607291,8.57660408 8.09051367,8.57660408 8.41445733,8.27018776 L10.758285,6.05395918 C11.0805717,5.74754286 11.0805717,5.25226122 10.758285,4.9458449 L8.41445733,2.72883265 C8.25207125,2.57601633 8.03997514,2.5 7.82787904,2.5 C7.61661143,2.5 7.40368683,2.57601633 7.24295775,2.72883265 Z",
    id: "Clip-2",
    fill: "#06749F",
    fillRule: "nonzero",
    transform: "translate(9.000000, 5.500000) rotate(-90.000000) translate(-9.000000, -5.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.5,
    x2: 18,
    y2: 0.5,
    id: "Line-6",
    stroke: "#06749F",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 17.5,
    x2: 18,
    y2: 17.5,
    id: "Line-6-Copy",
    stroke: "#06749F",
    strokeLinecap: "square"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogExpandRowsHover);
export default __webpack_public_path__ + "static/media/icon_log_expand_rows_hover.ac7f0e41c08751fc230cbc58bd6711a9.svg";
export { ForwardRef as ReactComponent };